// src/services/sickLeaveApi.js

import { useAuthStore } from '../stores/auth.js'

export const sickLeaveApi = {
  async createSickLeave({ worker, start_date, end_date, filled_by_manager = false }) {
    const authStore = useAuthStore()
    const response = await authStore.makeAuthenticatedRequest(
      '/api/sick-leaves/',
      {
        method: 'POST',
        body: JSON.stringify({
          worker,
          start_date,
          end_date,
          filled_by_manager
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    return await response.json()
  },
  
  async getSickLeaves({ worker_id, start_date, end_date }) {
    const authStore = useAuthStore()
    const params = new URLSearchParams()
    if (worker_id) params.append('worker', worker_id)
    if (start_date) params.append('start_date', start_date)
    if (end_date) params.append('end_date', end_date)
    
    const response = await authStore.makeAuthenticatedRequest(
      `/api/sick-leaves/?${params.toString()}`,
      {
        method: 'GET'
      }
    )
    return await response.json()
  },
  
  async notifyManager({ sick_leave_id }) {
    const authStore = useAuthStore()
    const response = await authStore.makeAuthenticatedRequest(
      `/api/sick-leaves/${sick_leave_id}/notify-manager/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    return await response.json()
  },

  async deleteSickLeave(sickLeaveId) {
    const authStore = useAuthStore()
    const response = await authStore.makeAuthenticatedRequest(
      `/api/sick-leaves/${sickLeaveId}/`,
      {
        method: 'DELETE'
      }
    )
    return response
  }
}
